import Slider from "react-slick";

import { SkillList } from "./Skill";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../helpers/overrides/slick.css';
import './skillScroller.css';

export default function SkillScroller() {

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 13,
        slidesPerRow: 1,

        responsive: [
            {
                breakpoint: 950,
                settings: {
                    slidesToShow: 10
                }
            }, {
                breakpoint: 650,
                settings: {
                    slidesToShow: 7
                }
            }
        ]
    };

    return (
        <div className="skill-scroller">
            <Slider {...settings}>
                {Object.entries(SkillList).map(([v, i]) => {
                    return <div className="skill-item" key={v}>
                        {i.component}
                        <span>{i.display}</span>
                    </div>;
                })}
            </Slider>
        </div>
    );
}

/*
    -HTML
    -CSS
    -JS
    -Node
    -C#
    -ASP.NET

    -SQL
    -MongoDB

    -jQuery
    -Bootstrap
    -GSAP
    -Shopify
    -Stripe

    -Github/git

    -Figma
    -Photoshop
    -XD

*/